// extracted by mini-css-extract-plugin
var _1 = "UserThemeSetting-module__formFooter--dj5C9";
var _2 = "UserThemeSetting-module__infoIcon--EzAJY";
var _3 = "UserThemeSetting-module__labelContainer--ZhOJl";
export { _1 as "formFooter", _2 as "infoIcon", _3 as "labelContainer" }
